import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import MonitorTable from '../layouts/components/monitor/MonitorTable';
import Toolbar from '../layouts/components/monitor/Toolbar';
import MonitorItem from '../layouts/components/monitor/MonitorItem';
import {AlertMonitorObject, BookmakerData, EventsStoredObjects, MonitorSettingsObject, User,} from '../@types/response';
import {getBookmakers} from '../store/selectors/getBookmakers';
import EventDetailsModal from '../layouts/components/modals/EventDetailsModal';
import {getMonitors} from '../store/selectors/monitor/getMonitors';
import {GetInitAction} from '../store/actions/monitor/GetInitAction';
import {GetActiveEventsAction} from '../store/actions/monitor/GetActiveEventsAction';
import BookEventModal from '../layouts/components/monitor/modals/BookEventModal';
import getClient from '../store/selectors/getClient';
import SignChartModal from '../layouts/components/modals/SignChartModal';
import HideAlertModal from '../layouts/components/monitor/modals/HideAlertModal';
import {AppDispatch} from "recharts/types/state/store";
import {getFixtures} from "../store/selectors/getFixtures";
import {getSettings} from "../store/selectors/monitor/getSettings";
import {sortEvent} from "../store/utils/monitorUtils";

const Monitor: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const fixtures: EventsStoredObjects = useSelector(getFixtures);
    const monitors: AlertMonitorObject[] = useSelector(getMonitors);
    const bookmakers: BookmakerData = useSelector(getBookmakers);
    const client: undefined | User = useSelector(getClient);
    const settings: MonitorSettingsObject = useSelector(getSettings);

    const sortedMonitors = useMemo(() =>
                    [...monitors].sort((a, b) => sortEvent(a, b, fixtures, settings)),
            [monitors, fixtures, settings]
    );

    useEffect(() => {
        dispatch(GetInitAction(client?.id || ''));
        dispatch(GetActiveEventsAction());
        document.title = 'MONITOR - OddMonitor';
    }, []);

    if (!Object.keys(bookmakers).length) {
        return <React.Fragment>
            <div
                    id='toolbar-monitor'
                    className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
            >
                <Toolbar/>
            </div>
            <div className='mt-16'>
                <MonitorTable/>
            </div>
            <div>Loading</div>
        </React.Fragment>;
    }

    return (
            <div>
                <div
                        id='toolbar-monitor'
                        className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
                >
                    <Toolbar/>
                </div>
                <div className='mt-16 mx-4'>
                    <MonitorTable>
                        {sortedMonitors
                                //TODO: move this check in utils?
                                .filter(alert => client?.client == null || client.client === alert.bookmakerId)
                                .map((alert: AlertMonitorObject, idx: number) => (
                                        <MonitorItem alert={alert} key={`${alert.id}x${idx}`}
                                                     event={fixtures[alert.id]}/>
                                ))}
                    </MonitorTable>
                </div>

                <EventDetailsModal/>
                <BookEventModal/>
                <SignChartModal/>
                <HideAlertModal/>
            </div>
    );
}

export default Monitor;
